import { RouterSelectors } from '@next/core-lib/router-store';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FeedProfitModuleState } from '../models/feed-profit.model';

export const getFeedProfitModuleState =
  createFeatureSelector<FeedProfitModuleState>('feedProfitModule');

export const getCalculations = createSelector(
  getFeedProfitModuleState,
  (state) => state.calculations,
);

export const getSelectedCalculation = createSelector(
  getFeedProfitModuleState,
  (state) => state.selectedCalculation,
);

export const getIsChanged = createSelector(getFeedProfitModuleState, (state) => state.isChanged);

export const getSelectedCalculationId = createSelector(
  getFeedProfitModuleState,
  RouterSelectors.getRouteParam('calculationId'),
  (state, calculationId) => {
    const routeCalculationId = parseInt(calculationId, 10);
    return !isNaN(routeCalculationId) && routeCalculationId > 0
      ? routeCalculationId
      : state.selectedCalculationId;
  },
);

export const getNextQuickSimulationId = createSelector(getSelectedCalculation, (calculation) =>
  calculation && calculation.comparisonSimulation && calculation.quickSimulations
    ? Math.max(
        ...[calculation.comparisonSimulation, ...calculation.quickSimulations].map((d) => d.id),
      ) + 1
    : 1,
);

export const getQuickSimulationCanBeCalculated = createSelector(
  getSelectedCalculation,
  (calculation) =>
    calculation &&
    calculation.feeders != null &&
    calculation.feeders.length > 0 &&
    calculation?.extendedSimulation?.calculatedFeeder != null &&
    calculation.baseLine != null &&
    Object.values(calculation.baseLine).every((val) => val != null) &&
    calculation.extendedBaseLine != null &&
    Object.values(calculation.extendedBaseLine).every((val) => val != null),
);

export const getExtendedSimulationCanBeCalculated = createSelector(
  getSelectedCalculation,
  (calculation) =>
    getQuickSimulationCanBeCalculated &&
    getExtendedComparisonCanBeCalculated &&
    calculation?.extendedSimulation?.feeders != null &&
    calculation?.extendedSimulation?.feeders.length > 0 &&
    calculation?.extendedSimulation?.calculatedFeeder != null &&
    calculation?.extendedSimulation?.baseLine != null &&
    calculation?.extendedSimulation?.extendedBaseLine != null &&
    Object.values(calculation?.extendedSimulation?.extendedBaseLine).every((val) => val != null),
);

export const getExtendedComparisonCanBeCalculated = createSelector(
  getSelectedCalculation,
  (calculation) =>
    getQuickSimulationCanBeCalculated &&
    calculation?.extendedComparisonSimulation?.feeders != null &&
    calculation?.extendedComparisonSimulation?.feeders.length > 0 &&
    calculation?.extendedComparisonSimulation?.calculatedFeeder != null &&
    calculation?.extendedComparisonSimulation?.baseLine != null &&
    calculation?.extendedComparisonSimulation?.extendedBaseLine != null &&
    Object.values(calculation?.extendedComparisonSimulation?.extendedBaseLine).every(
      (val) => val != null,
    ),
);

export const getHasExtendedSimulation = createSelector(
  getSelectedCalculation,
  (calculation) => calculation?.extendedSimulation != null,
);
